<template>
  <div class="container">
    <div class="col-lg-6 col-md-8 ml-auto mr-auto">
      <form @submit.prevent="setPassword">
        <card class="card card-white" header-classes="p-0">
          <template slot="header">
            <img src="img/card-info.png" alt=""/>
          </template>

          <div>
            <h1 class="card-title text-muted">{{ $t('passwordReset.title') }}</h1>
            <h5 class="card-title text-muted">{{ $t('passwordChange.view.helpText') }}</h5>

            <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
              {{ $t('passwordReset.failedText') }} ({{ error }})
            </base-alert>

            <base-input
              v-validate="'required|min:9'"
              name="password"
              :error="getError('password')"
              v-model="model.password"
              type="password"
              :placeholder="$t('passwordReset.passwordPlaceholder')"
              addon-left-icon="tim-icons icon-lock-circle"
              ref="password"
            >
            </base-input>
            <base-input
              name="confirm"
              :error="getError('confirm')"
              v-validate="'required|confirmed:password'"
              v-model="model.confirmedPassword"
              type="password"
              :placeholder="$t('passwordReset.confirmedPasswordPlaceholder')"
              addon-left-icon="tim-icons icon-single-copy-04"
            >
            </base-input>
          </div>

          <div slot="footer">
            <base-button native-type="submit" type="info" class="mb-3" size="lg" block :loading="loading">
              {{ $t('passwordReset.actionButtonText') }}
            </base-button>

            <!--            <div class="pull-right">-->
            <!--              <h6><a href="#" class="link footer-link"> {{ $t('passwordReset.helpLinkText') }}</a></h6>-->
            <!--            </div>-->
          </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import {BaseAlert} from 'src/components'

export default {
  components: {
    BaseAlert
  },
  data() {
    return {
      alert: false,
      error: null,
      model: {
        password: '',
        confirmedPassword: '',
        token: this.$route.query.token
      },
      loading: false
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async setPassword() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        this.alert = false;
        this.error = null;
        this.loading = true;
        // TIP use this.model to send it to api and perform login call
        this.$auth.register({
          url: 'o/auth/set-password',
          body: {
            password: this.model.password,
            token: this.model.token
          },
          fetchUser: false,
          redirect: null,
          autoLogin: false,
        }).then((resp) => {
          this.$auth.fetch().then(() => {
            this.error = null
            this.loading = false;

            // Depending on role, navigate to proper view.
            switch (this.$auth.user().role) {
              case 'reporter':
              case 'accountant':
                this.$router.push({name: "tickets"})
                break;
              case 'inspector':
              case 'inspector_team_lead':
                this.$router.push({name: "inspector_teams"})
                break;
              case 'service_desk':
              case 'service_desk_l2':
                this.$router.push({name: "search"})
                break;
              case 'super_viewer':
              case 'admin':
                this.$router.push({name: "home"})
                break;
              default:
                this.$router.push({name: "profile"})
            }
          }, (resp) => {
            this.loading = false;
            this.error = resp.bodyText;
            this.alert = true;
          })
        }, (resp) => {
          this.loading = false;
          this.error = resp.bodyText;
          this.alert = true;
        });
      }
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
